/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PageModel
 */
export interface PageModel {
    /**
     * 
     * @type {any}
     * @memberof PageModel
     */
    pageNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PageModel
     */
    pageSize?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PageModel
     */
    totalCount?: any | null;
}

/**
 * Check if a given object implements the PageModel interface.
 */
export function instanceOfPageModel(value: object): value is PageModel {
    return true;
}

export function PageModelFromJSON(json: any): PageModel {
    return PageModelFromJSONTyped(json, false);
}

export function PageModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageModel {
    if (json == null) {
        return json;
    }
    return {
        
        'pageNumber': json['pageNumber'] === undefined ? undefined : json['pageNumber'] === null ? null : json['pageNumber'],
        'pageSize': json['pageSize'] === undefined ? undefined : json['pageSize'] === null ? null : json['pageSize'],
        'totalCount': json['totalCount'] === undefined ? undefined : json['totalCount'] === null ? null : json['totalCount'],
    };
}

export function PageModelToJSON(json: any): PageModel {
    return PageModelToJSONTyped(json, false);
}

export function PageModelToJSONTyped(value?: PageModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'totalCount': value['totalCount'],
    };
}

